import {
	cloneValue,
	JsonSchemaDefinition,
	schemaType
} from "../../extensions/json-schema/runtime";

export interface EntitySchemaEntry {
	key: string;

	title: string;

	schema: JsonSchemaDefinition;

	value: unknown;
}

export function getEntityOverviewSchema(schema?: JsonSchemaDefinition): JsonSchemaDefinition | undefined {
	const overview = schema?.properties?.Overview;

	return overview && schemaType(overview) === "object" ? overview : undefined;
}

export function buildEntitySchemaEntries(
	schema?: JsonSchemaDefinition,
	entity: Record<string, unknown> = {}
): EntitySchemaEntry[] {
	return Object.entries(schema?.properties ?? {})
		.filter(([key, property]) => key !== "Overview"
			&& ["object", "array"].includes(schemaType(property)))
		.map(([key, property]) => ({
			key,
			title: property.title || key,
			schema: property,
			value: entity[key]
		}));
}

export function mergeEntitySchemaSection(
	entity: Record<string, unknown>,
	key: string,
	value: unknown
): Record<string, unknown> {
	const result = { ...entity };

	if(value === undefined) {
		delete result[key];
	} else {
		result[key] = cloneValue(value);
	}

	return result;
}
